import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {SharedValueService} from '../../services/shared-value.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.css']
})
export class LogoutPageComponent implements OnInit {

  constructor(private authentication: AuthenticationService,
              private shared: SharedValueService,
              private router: Router) { }

  ngOnInit() {
    // clear session info
    this.authentication.clearToken();
    this.shared.clearUserSession();
    this.router.navigate(['/login'], {replaceUrl: true});
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/logout-page/logout-page.component.ts